import React, { useState, useImperativeHandle, forwardRef } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

const StripeCheckout = forwardRef(({ product, onCardStateChange }, ref) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useImperativeHandle(ref, () => ({
    handleSubmit,
  }));

  const handleSubmit = async (event) => {

    if (!stripe || !elements) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const cardElement = elements.getElement(CardElement);

      if (!cardElement) {
        setError("Card element is not available.");
        return { error: "Card element is not available." };
      }

      // const { token, error } = await stripe.createToken(cardElement);
      const {
        paymentMethod, error } = await stripe.createPaymentMethod({
          type: 'card',
          card: cardElement,
        });
      // console.log(paymentMethod, "paymentMethodpaymentMethod")

      if (error) {
        setError(error.message);
      } else {
        setSuccess("Token created successfully!");
        return { paymentMethod };
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
      return { error: "An error occurred" };
    } finally {
      setLoading(false);
    }
  };

  const handleCardChange = (event) => {
    if (event.error) {
      setError(event.error ? event.error.message : null);
      // onCardStateChange(!event.empty && !event.error);
    } else {
      setError(null);
    }
  };

  return (
    <CardElement
      options={{
        style: {
          base: {
            fontSize: "16px",
            color: "#424770",
            letterSpacing: "0.025em",
            fontFamily: "Source Code Pro, monospace",
            "::placeholder": {
              color: "#aab7c4",
            },
          },
          invalid: {
            color: "#9e2146",
          },
        },
      }}
      onChange={handleCardChange}
    />
  );
});

export default StripeCheckout;
